module.exports = __webpack_public_path__ + "img/gem8_color1.5ec85257.png";